import styled from 'styled-components';
import { Tooltip as AntTooltip } from 'antd';
import { theme, Flex } from 'modules/ui';

export const StyledTooltip = styled(AntTooltip)`
  .ant-tooltip {
    max-width: none;

    transform: translate3d(0, 0, 0);
    // if removed, .ant-tooltip-arrow disappears in some resolutions for Safari
    -webkit-transform: translate3d(0, 0, 0);
  }
  .ant-tooltip-content {
    left: 0.563rem;
  }
  .ant-tooltip-inner {
    ${({theme}) => `
        color: ${theme.colors.primaryK9};
        background-color: ${theme.colors.primaryT3}!important;
        box-shadow: none;
        font-weight: ${theme.fontWeight.normal};
        font-size: var(--main-font-size);
        line-height: var(--main-line-height);
        padding: 0.75rem 1rem;
        border-radius: 0 4px 4px 4px;
        width: 14.2rem;
     `
     }
  }

  .ant-tooltip-arrow {
    left: 0;
    width: 1.469rem;
    height: 1.469rem;
    overflow: hidden;
  }
  .ant-tooltip-placement-topLeft,
  .ant-tooltip-placement-topRight {
    padding-bottom: 1.3rem;
    .ant-tooltip-arrow {
      top: unset;
      transform: scale(1, -1);
      bottom: -1.41rem;
    }
    .ant-tooltip-inner {
      border-radius: 4px 4px 4px 0;
    }
  }

  .ant-tooltip-arrow-content {
    ${({theme}) => `
        --antd-arrow-background-color: ${theme.colors.primaryT3}!important;
        box-shadow: none !important;
    
        background: ${theme.colors.primaryT3};
        content: ' ';
        display: block;
        width: 2.938rem;
        height: 2.938rem;
        transform: translateY(1.469rem) translateX(-1.469rem) translateZ(0)
          rotate(45deg);
    `}

  .ant-tooltip-arrow-content:before {
    display: none !important;
  }

  div.ant-tooltip.ant-tooltip-placement-topRight {
    left: unset !important;
  }
`;

export const TooltipIcon = styled(Flex)<{ active?: boolean }>`
  display: inline-block;
  margin: 0 0.5rem;
  height: 1.5rem;
  top: 0.125rem;
  position: relative;

  svg path {
    transform: fill 0.15s linear;
    ${(props) => (props.active ? `fill: ${props.theme.colors.primaryT2};` : '')};
  }
`;
